module.exports = __webpack_public_path__ + "static/assets/db4e6476e6664d41bf7b5b6ca8e093db.gif";